/**
 * Shared GTM Leads risk / product disclosure copy (story 11.15).
 * Keep Settings, Approve, and empty-state surfaces aligned with arch Risk section.
 */

export const GTM_SESSION_RISK_NOTICE =
  "Pasting a LinkedIn member session cookie can violate LinkedIn’s terms and may risk account restriction. TypeCRM uses the cookie only for people search and sequence steps on linkedin.com. Find leads never sends invitations; outreach runs only after you Approve a lead and while sequence is Running.";

export const GTM_SESSION_TOS_CHECKBOX =
  "I understand the risks and authorize TypeCRM to use this session cookie for LinkedIn people search and sequence steps on linkedin.com only.";

export const GTM_APPROVE_CREATES_CONTACT =
  "Approving starts the LinkedIn sequence. Email is optional — LinkedIn does not provide it; add one later to create a Contact.";

export const GTM_FIRST_APPROVE_RISK_REMINDER =
  "LinkedIn session-cookie automation can violate LinkedIn’s terms and risk account restriction. Outreach runs only while sequence is Running and Automation advances enrollments — not at the moment you Approve.";

export const GTM_FIND_LEADS_NO_INVITES =
  "Find leads never sends invitations; outreach starts only after Approve.";

export const GTM_FIND_LEADS_OVERVIEW =
  "Find people on LinkedIn from this play’s audience and your brain. No invites are sent.";

export const GTM_SESSION_EXPIRED_BANNER =
  "LinkedIn session expired. Connect a fresh session in Settings. Sequence is paused; enrollments keep their current step until you resume.";

export const GTM_SESSION_MISSING_BANNER =
  "No LinkedIn session connected. Paste a member cookie in Settings before Find leads or sequence outreach. Find leads never sends invites.";

export const GTM_SEQUENCE_PAUSED_KEEP_STEP =
  "When paused, Automation will not advance LinkedIn outreach. Enrollments keep their current step until you resume.";
